import React, { PropsWithChildren } from 'react';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { Modal, Button } from 'react-bootstrap';
import './index.css';
import { PatientContext } from '../../../contexts/patient';
import { IQuestionnaireResponse } from '../../../modules/unsw-fhir/QuestionnaireResponse';
import { IQuestionnaire } from '../../../modules/unsw-fhir/Questionnaire';
import PDFQuestionnaire from '../../PdfGenerator';

// This is the modal which displays the MyChoices PDF for review/download/printing
const MyChoicesPDF = ({
  show,
  handleClose,
  patientContext,
  questionnaireResponses,
  questionnaires,
}: PropsWithChildren<{
  show: boolean;
  handleClose: () => void;
  patientContext: PatientContext;
  questionnaireResponses: {
    data: IQuestionnaireResponse[];
    isLoading: boolean;
    isError: boolean;
  };
  questionnaires: {
    data: IQuestionnaire[];
    isLoading: boolean;
    isError: boolean;
  };
}>) => {
  return (
    <Modal
      dialogClassName="modal-xl"
      show={show}
      onHide={handleClose}
      scrollable={true}>
      <Modal.Body>
        <PDFViewer width="100%" height="98%">
          <PDFQuestionnaire
            questionnaireResponses={questionnaireResponses}
            questionnaires={questionnaires}
            birthDate={patientContext.getDateOfBirth()}
            displayName={patientContext.getDisplayName()}
            mrn={patientContext.getMrn()}
          />
        </PDFViewer>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        {/* Downlaod Button for PDF */}
        <PDFDownloadLink
          className="btn btn-primary"
          document={
            <PDFQuestionnaire
              questionnaireResponses={questionnaireResponses}
              questionnaires={questionnaires}
              birthDate={patientContext.getDateOfBirth()}
              displayName={patientContext.getDisplayName()}
              mrn={patientContext.getMrn()}
            />
          }
          fileName={patientContext.getDisplayName() + ' Responses.pdf'}>
          {({ url, loading }) => {
            console.log(url);
            return loading ? 'Loading document...' : 'Download';
          }}
        </PDFDownloadLink>
      </Modal.Footer>
    </Modal>
  );
};

export default MyChoicesPDF;
